import * as stylex from "@stylexjs/stylex";
import { useState } from "react";

import { layout, spacing, table, text } from "@animus/primaris";

import type { ModifierDefinition } from "./types.ts";
import { ModifierDetailModal } from "./modifier-detail-modal.tsx";
import { ModifierRow } from "./modifier-row.tsx";

interface AdminModifiersProps {
  modifiers: ModifierDefinition[];
}

function AdminModifiers({ modifiers }: AdminModifiersProps) {
  const [selectedModifier, setSelectedModifier] =
    useState<ModifierDefinition | null>(null);

  return (
    <div>
      <div {...stylex.props(spacing.mb6, layout.flexBetween)}>
        <div>
          <h1 {...stylex.props(text.bold, text["2xl"], text.white)}>
            Food Modifiers
          </h1>
          <p {...stylex.props(text.sm, text.muted)}>
            Cooking methods, preparation techniques, and additions affecting
            nutrition calculations
          </p>
        </div>
      </div>

      <div {...stylex.props(table.container)}>
        <table {...stylex.props(table.table)}>
          <thead {...stylex.props(table.thead)}>
            <tr>
              <th {...stylex.props(table.th)}>Name</th>
              <th {...stylex.props(table.th)}>Slug</th>
              <th {...stylex.props(table.th)}>Category</th>
              <th {...stylex.props(table.th)}>Exclusive Group</th>
              <th {...stylex.props(table.th)}>Rules</th>
              <th {...stylex.props(table.th)}>Description</th>
              <th {...stylex.props(table.th, table.thRight)}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {modifiers.map((modifier) => (
              <ModifierRow
                key={modifier.slug}
                modifier={modifier}
                onViewDetails={() => setSelectedModifier(modifier)}
              />
            ))}
            {modifiers.length === 0 && (
              <tr>
                <td {...stylex.props(table.empty)} colSpan={7}>
                  No modifiers found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {selectedModifier && (
        <ModifierDetailModal
          modifier={selectedModifier}
          onClose={() => setSelectedModifier(null)}
        />
      )}
    </div>
  );
}

export { AdminModifiers, type AdminModifiersProps };
